import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { productQuantityBySupplierInventoryLevelsSelector, hideLEInStockSelector } from '../../../redux/product/product.selectors';
import { LimitedEditionInStockComponent } from './limited-edition-in-stock';
const mapStateToProps = createStructuredSelector({
  inStock: productQuantityBySupplierInventoryLevelsSelector,
  hideLEInStock: hideLEInStockSelector
});
export const LimitedEditionInStock = connect(mapStateToProps)(LimitedEditionInStockComponent);